// extracted by mini-css-extract-plugin
export var cartContainer = "_oi-4";
export var gray = "_oi-1";
export var itemContainer = "_oi-2";
export var itemDetails = "_oi-3";
export var strong = "_oi-0";